import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What exactly will I get in the scorecard?",
    a: "An overall AI commercial maturity score (0–100), per-dimension scores across 5 areas, your strengths, your gaps, a prioritised list of recommended growth moves. All generated against your specific answers and delivered as a PDF to your inbox.",
  },
  {
    q: "Who is this audit for?",
    a: "Construction, property and professional services firms that are growing but flying blind on revenue, aware of AI, unsure how to make it work inside the business without breaking operations or wasting budget on tools that go nowhere.",
  },
  {
    q: "How long does it take?",
    a: "About 4 to 5 minutes. There are 15 questions and a short lead form so we can address the report to the right person and send the PDF to the right inbox.",
  },
  {
    q: "Is this a free discovery call?",
    a: "No. The on-screen scorecard and PDF are free, but the follow-up engagement is paid. Your time and mine are worth protecting, and the engagement is built to create measurable commercial return from day one.",
  },
  {
    q: "Who is behind the audit?",
    a: "Faisal Amin, founder of an AI-powered business development consultancy. 80+ face-to-face and virtual AI audits delivered this year across construction, property and professional services. Featured AI speaker at UK Construction Week.",
  },
  {
    q: "Will my data be shared?",
    a: "No. Your answers are stored privately to generate your report and email the PDF. We never sell or share your data, and you can request deletion at any time.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32 border-t border-white/10">
      <div className="mx-auto max-w-3xl px-6 md:px-12">
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#00E5FF]">/ FAQ</div>
        <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tighter mt-4">
          Questions, answered.
        </h2>

        <Accordion type="single" collapsible className="mt-12 w-full" data-testid="faq-accordion">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-heading text-lg md:text-xl font-medium tracking-tight text-left hover:text-[#00E5FF] hover:no-underline py-6">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/65 text-base leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
